import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export function downloadExcel(s) {
	var buf = new ArrayBuffer(s.length);
	var view = new Uint8Array(buf);

	for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;

	return buf;
}

export function ExcelUnidadesProducidas(data_excel, Year, Mes) {
	var wb = XLSX.utils.book_new();

	// crear hoja de prueba
	wb.SheetNames.push('Reporte');

	// Insertar contenido dentro de la hoja
	data_excel.unshift(
		[ `REPORTE/UNIDADES PRODUCIDAS` ],
		[ `AÑO:${Year}` ],
		[ `MES:${Mes}` ],
		[],
		[ 'Dia', 'Articulo', 'Cantidad', 'Planta' ]
	);

	// cree la hoja d eesta matriz
	var ws = XLSX.utils.aoa_to_sheet(data_excel);

	// Aignar el objeto de hoja a la matriz.
	wb.Sheets['Reporte'] = ws;

	// Generar el archivo excel
	var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

	saveAs(
		new Blob([ downloadExcel(wbout) ], { type: 'application/octet-stream' }),
		'Reporte/unidades/producidas.xlsx'
	);
	data_excel.shift();
}

export function ExcelExistenciaActual(data_excel, date) {
	var wb = XLSX.utils.book_new();

	// crear hoja de prueba
	wb.SheetNames.push('Reporte');

	// Insertar contenido dentro de la hoja
	data_excel.unshift(
		[ `REPORTE/EXISTENCIA ACTUAL` ],
		[ `FECHA:${date}` ],
		[],
		[ 'Planta', 'Codigo', 'Descripcion', 'Disponible', 'Fraguado', 'En proceso' ]
	);

	// cree la hoja d eesta matriz
	var ws = XLSX.utils.aoa_to_sheet(data_excel);

	// Aignar el objeto de hoja a la matriz.
	wb.Sheets['Reporte'] = ws;

	// Generar el archivo excel
	var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

	saveAs(new Blob([ downloadExcel(wbout) ], { type: 'application/octet-stream' }), 'Reporte/existencia/actual.xlsx');
	data_excel.shift();
}

export function ExcelDespachosDiarios(data_excel, year) {
	var wb = XLSX.utils.book_new();

	// crear hoja de prueba
	wb.SheetNames.push('Reporte');

	// Insertar contenido dentro de la hoja
	data_excel.unshift(
		[ `REPORTE/DESPACHOS DIARIOS` ],
		[ `AÑO:${year}` ],
		[],
		[
			'Fecha',
			'Familia',
			'Cantidad Viaje',
			'Despachos Clientes',
			'Despachos Macizo',
			'Total Despachos',
			'Unidades Producidas'
		]
	);

	// cree la hoja d eesta matriz
	var ws = XLSX.utils.aoa_to_sheet(data_excel);

	// Aignar el objeto de hoja a la matriz.
	wb.Sheets['Reporte'] = ws;

	// Generar el archivo excel
	var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

	saveAs(new Blob([ downloadExcel(wbout) ], { type: 'application/octet-stream' }), 'Reporte/despachos/diarios.xlsx');
	data_excel.shift();
}

export function ExcelDespachosDiariosDestallados(data_excel, year, month, planta) {
	var wb = XLSX.utils.book_new();

	// crear hoja de prueba
	wb.SheetNames.push('Reporte');

	// Insertar contenido dentro de la hoja
	data_excel.unshift(
		[ `REPORTE/DESPACHOS DIARIOS DETALLADO` ],
		[ `AÑO:${year}` ],
		[ `MES:${month}` ],
		[ `PLANTA:${planta}` ],
		[],
		[
			'Codigo',
			'Descripcion',
			'Total',
			'Participacion',
			'Promedio',
			'D1',
			'D2',
			'D3',
			'D4',
			'D5',
			'D6',
			'D7',
			'D8',
			'D9',
			'D10',
			'D11',
			'D12',
			'D13',
			'D14',
			'D15',
			'D16',
			'D17',
			'D18',
			'D19',
			'D20',
			'D21',
			'D22',
			'D23',
			'D24',
			'D25',
			'D26',
			'D27',
			'D28',
			'D29',
			'D30',
			'D31'
		]
	);

	// cree la hoja d eesta matriz
	var ws = XLSX.utils.aoa_to_sheet(data_excel);

	// Aignar el objeto de hoja a la matriz.
	wb.Sheets['Reporte'] = ws;

	// Generar el archivo excel
	var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

	saveAs(
		new Blob([ downloadExcel(wbout) ], { type: 'application/octet-stream' }),
		'Reporte/despachos/diarios/detalaldos.xlsx'
	);
	data_excel.shift();
}

export function ExcelReporte(data_excel, columns, name) {
	let columnas = [];
	columns.forEach((element) => {
		columnas.push(element.Header);
	});
	var wb = XLSX.utils.book_new();

	// crear hoja de prueba
	wb.SheetNames.push('Reporte');

	// Insertar contenido dentro de la hoja
	data_excel.unshift(
		[ `REPORTE/${name}` ],
		//[ `AÑO:${year}` ],
		//[ `MES:${month}` ],
		//[ `PLANTA:${planta}` ],
		[],
		columnas
	);

	// cree la hoja d eesta matriz
	var ws = XLSX.utils.aoa_to_sheet(data_excel);

	// Aignar el objeto de hoja a la matriz.
	wb.Sheets['Reporte'] = ws;

	// Generar el archivo excel
	var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

	saveAs(new Blob([ downloadExcel(wbout) ], { type: 'application/octet-stream' }), '"' + name + '".xlsx');
	data_excel.shift();
}

export function ExcelReporte_OEE(data_excel, name) {
	var wb = XLSX.utils.book_new();

	// crear hoja de prueba
	wb.SheetNames.push('Reporte');

	// Insertar contenido dentro de la hoja
	data_excel.unshift(
		[ `REPORTE/${name}` ]
		//[ `AÑO:${year}` ],
		//[ `MES:${month}` ],
		//[ `PLANTA:${planta}` ],
		//[],
		//columnas
	);
	//var merge = { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } };
	var merge = XLSX.utils.decode_range('A2:G2');
	var merge1 = XLSX.utils.decode_range('H2:L2');
	var merge2 = XLSX.utils.decode_range('M2:S2');
	var merge3 = XLSX.utils.decode_range('T2:Z2');

	// cree la hoja d eesta matriz
	var ws = XLSX.utils.aoa_to_sheet(data_excel);

	if (!ws['!merges']) ws['!merges'] = [];
	ws['!merges'].push(merge);
	if (!ws['!merges']) ws['!merges'] = [];
	ws['!merges'].push(merge1);
	if (!ws['!merges']) ws['!merges'] = [];
	ws['!merges'].push(merge2);
	if (!ws['!merges']) ws['!merges'] = [];
	ws['!merges'].push(merge3);

	// Aignar el objeto de hoja a la matriz.
	wb.Sheets['Reporte'] = ws;

	// Generar el archivo excel
	var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

	saveAs(new Blob([ downloadExcel(wbout) ], { type: 'application/octet-stream' }), '"' + name + '".xlsx');
	data_excel.shift();
}
